//引入Vue
import Vue from 'vue'
//引入App
import App from './App.vue'
//引入VueRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'

import axios from "axios";

import '../public/theme/index.css'

import ElementUI from 'element-ui';

// import 'element-ui/lib/theme-chalk/index.css';

import Global from './components/Global'

Vue.prototype.GLOBAL = Global 

Vue.use(ElementUI);

axios.interceptors.request.use(config => {
	config.headers.Authorization = localStorage.getItem("token")
	console.log(config)
	return config
}, error => {
	// 请求失败的处理
	return Promise.reject(error);
})

axios.interceptors.response.use(response => {
	return response;
}, error => {
	if (error.response.status === 401) {
		alert("身份验证过期")
		localStorage.removeItem("token");
		window.location.href = "http://localhost:8082/login"
	}
	// 对响应错误做点什么
	return Promise.reject(error);
});

// 定入到原型链，使用this可以找到使用
Vue.prototype.$http = axios
//关闭Vue的生产提示
Vue.config.productionTip = false
//应用插件
Vue.use(VueRouter)

//创建vm
new Vue({
	el: '#app',
	render: h => h(App),
	router
})
